/**
 * ContentDirectorLayout — Thin wrapper around ControllerLayout
 * that forces "contentDirector" mode.
 *
 * Features vs Content Controller:
 *  ✅ Discover, Explore, Cut, VTR, Summaries, Feed (stream only)
 *  ✅ Settings → Participants, Tags, Rundowns
 *  🚫 Dashboard (Controller-only)
 *
 * Route: /contentdirector
 */
import React from "react";
import { ControllerLayout } from "./ControllerLayout";

export const ContentDirectorLayout: React.FC = () => {
  return <ControllerLayout mode="contentDirector" />;
};
